import { connect } from 'react-redux';
import { applySpec } from 'ramda';
import moment from 'moment';

import AddTransmissionReport from 'components/AddTransmissionReport';
import {
  getNewReportStep,
  getDeviceVendor,
  getTransmissionType,
  getPdfReportFileObject,
  getUnscheduledVisitReason,
} from 'store/selectors/newReport';
import { newReportReset, reportCreate } from 'store/actionCreators/newReport';
import { fetchOrganization } from 'store/actionCreators/organization';

const mapStateToProps = applySpec({
  step: getNewReportStep,
  deviceVendor: getDeviceVendor,
  transmissionType: getTransmissionType,
  pdfFileObject: getPdfReportFileObject,
  unscheduledVisitReason: getUnscheduledVisitReason,
});

const mapDispatchToProps = dispatch => {
  const initTime = moment.now();
  dispatch(fetchOrganization());
  return {
    onSubmit: () => dispatch(reportCreate({ initTime })),
    newReportReset: () => dispatch(newReportReset()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddTransmissionReport);
